var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoingpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.198 20.523H18.303"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 12.747,
    cy: 20.583,
    r: 1.696
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.081 14.934l5.589 5.589-5.589 5.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingpayment);
export default __webpack_public_path__ + "static/media/outgoingpayment.31aea4d1866a18efdd9d42827241f58d.svg";
export { ForwardRef as ReactComponent };